import { createFileRoute, notFound } from '@tanstack/react-router';

import { flagBasedComponent } from '@mint-lib/routing-context';
import { buildGuards, hasPermission } from '@mint-lib/routing-guards';

import { FlowPageSkeleton } from '@myn/approval_v2/routes';

const guard = buildGuards(hasPermission('approvalFlowFeature:modify'));

export const Route = createFileRoute(
  '/_secured/company-profile/flows/new-flow/',
)({
  async beforeLoad({ context }) {
    const guardsContext = await context.getGuardContext();

    if (!guard(guardsContext)) {
      throw notFound();
    }
  },

  async loader({ context }) {
    const isNewApprovalMicroEnabled = await context.isFlagEnabled(
      '@mint/arm',
      'newApprovalMicro',
    );
    const i18n = await context.getInstance('i18n', '@mint/routing');

    if (isNewApprovalMicroEnabled) {
      await Promise.all([
        context.getInstance('i18n', '@myn/approval_v2'),
        context.getInstance('i18n', '@mint-lib/ag-grid'),
      ]);
    } else {
      await context.getInstance('i18n', '@myn/approval');
    }

    const title = i18n.t('Create a flow | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
  pendingComponent: flagBasedComponent(
    'newApprovalMicro',
    '@mint/arm',
    FlowPageSkeleton,
    () => null,
  ),
});
